var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1891.201,
    height: 3532.423,
    viewBox: "0 0 1891.201 3532.423",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    opacity: 0.25,
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1878322497760"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M487.734,3532.255H640.759L1685.066,1907.387l133.167-204.422L1675.721,1505.55,587.025,1H434L1522.7,1505.55l142.512,197.414-133.167,204.422Z",
    transform: "translate(72.968 0.168)",
    fill: "#373435",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M0,0,1226.536,1693.787,19.858,3532.423H387.819L1407.6,1944.935l170.547-259.325-182.228-251.148L357.448,0Z",
    fill: "#373435",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowlogo);
export default __webpack_public_path__ + "static/media/Arrow logo.c30df320860fc7a26e16539d79b260ff.svg";
export { ForwardRef as ReactComponent };